import "./styles.css";
import { DatePicker } from "antd";

const DateSelect = (props) => {
  return <DatePicker changeOnBlur {...props} className="date-picker" format={"DD/MM/YYYY"} />;
};

export { DateSelect };
